module.exports = __webpack_public_path__ + "img/ic_20_premium.cd0d3d8d.svg";